import { render } from "./TermsModalWithButton.vue?vue&type=template&id=f3214e6e&ts=true"
import script from "./TermsModalWithButton.vue?vue&type=script&lang=ts"
export * from "./TermsModalWithButton.vue?vue&type=script&lang=ts"

import "./TermsModalWithButton.vue?vue&type=style&index=0&id=f3214e6e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__